
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface TypeContextProps {
  community: string;
  setSelectedCommunity: (text: string) => void;
}

const SocialContext = createContext<TypeContextProps | undefined>(undefined);

export const useSocialContext = (): TypeContextProps => {
  const context = useContext(SocialContext);
  if (!context) {
    throw new Error('useSocialContext must be used within a SocialProvider');
  }
  return context;
};

interface SocialProviderProps {
  children: ReactNode;
}

export const SocialProvider: React.FC<SocialProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [community, setSelectedCommunity] = useState<string>("GLOBAL");

  useEffect(() => {
    const regex = new RegExp("^\/user\/[^\/]+$")
    if (regex.test(location.pathname)) {
      setSelectedCommunity("");
    } else {
      if (location.state?.community) {
        setSelectedCommunity(location.state.community);
        // Clear the state after using it
        navigate(location.pathname, { replace: true, state: {} });
      }
    }
  }, [location.state, navigate]);

  return (
    <SocialContext.Provider value={{ community, setSelectedCommunity }}>
      {children}
    </SocialContext.Provider>
  );
};
